import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import 'fineuploader';
import dot from 'dot/doT';

function ServiceImageUploader() {
    this.defaultAttrs({
        s3BucketInputSelector: null,
        s3ObjectInputSelector: null,
        imageSize: 575,

        uploaderSelector: '[data-service-image-uploader]',
        uploaderTemplateSelector: '[data-service-image-uploader-template]',
        uploaderAddButton: '[data-service-image-add-button]',
        uploaderCancelButton: '[data-service-image-cancel-button]',
        uploaderProgress: '[data-service-image-progress]',
        uploadedImage: '[data-service-image-uploaded-image]',
        uploaderError: '[data-service-image-error-container]',
    });

    this.after('initialize', function() {
        // Initialize Fineuploader
        this.initializeUploader();

        // Image upload started
        this.on('uiServiceUploadStarted', this.hideUploadButton);
        this.on('uiServiceUploadStarted', this.hideUploadedImage);
        this.on('uiServiceUploadStarted', this.showProgress);

        // Image finished uploading
        this.on('uiServiceUploadComplete', this.showUploadedImage);
        this.on('uiServiceUploadComplete', this.hideProgress);
        this.on('uiServiceUploadComplete', this.fillHiddenFields);

        // Error
        this.on('uiServiceUploadFailed', this.showErrorMessage);

        // Image upload canceled
        this.on('uiServiceUploadCanceled', this.showUploadButton);
        this.on('uiServiceUploadCanceled', this.hideProgress);
    });

    this.showUploadButton = function() {
        this.select('uploaderSelector')
            .find(this.attr.uploaderAddButton)
            .attr('data-active', 'true');
    };

    this.hideUploadButton = function() {
        this.select('uploaderSelector')
            .find(this.attr.uploaderAddButton)
            .removeAttr('data-active');
    };

    this.showProgress = function() {
        this.select('uploaderSelector')
            .find(this.attr.uploaderProgress)
            .attr('data-active', 'true');
    };

    this.hideProgress = function() {
        this.select('uploaderSelector')
            .find(this.attr.uploaderProgress)
            .removeAttr('data-active');
    };

    this.showUploadedImage = function(event, data) {
        const $image = this.select('uploaderSelector').find(this.attr.uploadedImage);
        $image.attr('data-active', 'true');
        $image.find('img').attr('src', data.imageUrl);
    };

    this.hideUploadedImage = function() {
        const $image = this.select('uploaderSelector').find(this.attr.uploadedImage);
        $image.removeAttr('data-active');
    };

    this.fillHiddenFields = function(event, data) {
        this.select('s3BucketInputSelector').val(data.bucketName);
        this.select('s3ObjectInputSelector').val(data.objectKey);
    };

    this.showErrorMessage = function(event, data) {
        const error =
            '<div class="alert alert--error">' +
            '<i class="icon icon--info-1 alert__icon"></i>' +
            '<span class="alert__body">' +
            '{{!it.errorReason}}' +
            '</span>' +
            '</div>';
        const template = dot.template(error);
        const templateHtml = template({
            errorReason: data.errorReason,
        });
        this.select('uploaderError').html(templateHtml);
    };

    this.hideErrorMessages = function() {
        this.select('uploaderError').html('');
    };

    // Fineuploader: Initialize Fineuploader on uploader-element
    this.initializeUploader = function() {
        const successParams = {};

        successParams[this.attr.csrfParam] = this.attr.csrfToken;
        successParams.imageSize = this.attr.imageSize;

        this.select('uploaderSelector')
            .fineUploaderS3({
                debug: this.select('uploaderSelector').data('uploader-debug'),
                multiple: false,
                template: this.select('uploaderTemplateSelector'),
                validation: {
                    allowedExtensions: ['jpg', 'gif', 'png'],
                    image: {
                        minHeight: 300,
                        minWidth: 300,
                    },
                },
                showMessage() {
                    // TODO: Update as soon as error-messages are available
                    // - Supress Fineuploader alerts
                    // - Currently everything is handled in error-callback
                },
                request: {
                    endpoint: this.select('uploaderSelector').data('uploader-endpoint'),
                    accessKey: this.select('uploaderSelector').data('uploader-access-key'),
                },
                signature: {
                    endpoint: this.select('uploaderSelector').data('uploader-signature-endpoint'),
                    customHeaders: { 'X-CSRF-Token': this.attr.csrfToken },
                },
                uploadSuccess: {
                    endpoint: this.select('uploaderSelector').data('uploader-success-endpoint'),
                    params: successParams,
                },
                iframeSupport: {
                    localBlankPagePath: this.select('uploaderSelector').data(
                        'uploader-success-blank-url'
                    ),
                },
            })

            // Image was selected by user (from file-system)
            .on('submitted', () => {
                this.hideErrorMessages();
                this.trigger('uiServiceAutomaticUploadStarted');
            })

            // Upload to S3 started
            .on('upload', () => {
                this.trigger('uiServiceUploadStarted');
            })

            // Upload to S3 started
            .on('cancel', () => {
                this.trigger('uiServiceUploadCanceled');
            })

            // Upload is complete
            .on('complete', (event, id, name, responseJSON) => {
                this.trigger('uiServiceUploadComplete', responseJSON);

                // Make sure that error messages are only hidden if upload
                // succeeded (e.g. 403 is complete, but not successful)
                if (responseJSON.success) {
                    this.hideErrorMessages();
                }
            })

            // Something went wrong
            .on('error', (event, id, name, errorReason, xhr) => {
                this.trigger('uiServiceUploadFailed', {
                    id,
                    name,
                    errorReason,
                    xhr,
                    url: this.attr.backupUrl,
                });
            });
    };
}

export default defineComponent(ServiceImageUploader);



// WEBPACK FOOTER //
// ./src/js/component_ui/service-image-uploader.js